import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

const NotFound = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-24">
      <div className="max-w-lg w-full text-center">
        <p className="font-display text-[90px] leading-none text-gold-gradient mb-2">404</p>
        <div className="w-14 h-14 rounded-full border border-[#c9a24b]/40 flex items-center justify-center mx-auto mb-6">
          <Compass size={24} className="text-[#c9a24b]" strokeWidth={1.4} />
        </div>
        <h1 className="font-display text-3xl md:text-4xl text-[#f4efe4] mb-4">This page can't be found</h1>
        <p className="text-[#a29a8c] mb-8">
          The page you're looking for may have moved. Explore our collection of
          natural rituals instead.
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <Link to="/shop" className="btn-gold px-9 py-3 rounded-full text-sm tracking-[0.15em] uppercase">
            Shop the Collection
          </Link>
          <Link to="/" className="btn-outline-gold px-9 py-3 rounded-full text-sm tracking-[0.15em] uppercase">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
